import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import * as $ from 'jquery';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-professional-editing-service',
  templateUrl: './professional-editing-service.component.html',
  styleUrls: ['./professional-editing-service.component.scss']
})
export class ProfessionalEditingServiceComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('エナゴによる英文校正サービス｜Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: "博士号・修士号取得の英語ネイティブの専門校正者による校正で、論文出版の可能性をさらに高められます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "エナゴによる英文校正サービス｜Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "博士号・修士号取得の英語ネイティブの専門校正者による校正で、論文出版の可能性をさらに高められます。"});
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/professional-editing-service' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    if (isPlatformBrowser(this.platformId)){
      // $.getScript('../../../assets/js/particles.min.js', function(){});
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  

}
